import { render, staticRenderFns } from "./Consultoria.vue?vue&type=template&id=34e37844"
import script from "./Consultoria.vue?vue&type=script&lang=js"
export * from "./Consultoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports